import { Document, Image, Page } from '@react-pdf/renderer';
import PropTypes from 'prop-types';
import React from 'react';

import { styles } from './styles';

const ImageInvoicePdf = ({ imageSource, orientation }) => (
  <Document>
    <Page orientation={orientation} size="A4" style={styles.page}>
      <Image src={imageSource} style={styles.image} />
    </Page>
  </Document>
);

ImageInvoicePdf.propTypes = {
  imageSource: PropTypes.string.isRequired,
  orientation: PropTypes.string.isRequired,
};

export default ImageInvoicePdf;
